import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LayerItem = ({ layer, onToggle, isLight }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const hasChildren = layer.sublayers && layer.sublayers.items && layer.sublayers.items.length > 0;

    useEffect(() => {
        if (layer._forceOpen) {
            setIsOpen(true);
            delete layer._forceOpen;
        }
    }, [layer._forceOpen]);

    const textColor = isLight ? "#000000" : "#ffffff";
    
    // ვამოწმებთ, შვილებიდან რომელიმე მაინც თუ არის ჩართული
    const anyChildVisible = hasChildren && layer.sublayers.items.some(s => s.visible);

    const handleToggleAllChildren = (e) => {
        e.stopPropagation();
        if (hasChildren) {
            // თუ რომელიმე ჩართულია - ყველას ვთიშავთ, თუ არადა - ყველას ვრთავთ
            const targetState = !anyChildVisible;
            layer.sublayers.items.forEach((sub) => {
                if (sub.visible !== targetState) {
                    onToggle(sub);
                }
            });
        }
    };

    return (
        <div style={{ marginLeft: "10px", marginTop: "5px" }}>
            <div style={{ display: "flex", alignItems: "center", padding: "4px 0" }}>
                
                {/* 1. ისარი */}
                <div
                    onClick={() => setIsOpen(!isOpen)}
                    style={{
                        width: "15px",
                        cursor: "pointer",
                        ...(hasChildren ? {} : { visibility: "hidden" }),
                        fontSize: "10px",
                        color: isLight ? "#555" : "#bbb"
                    }}
                >
                    {isOpen ? "▼" : "▶"}
                </div>

                {/* 2. მშობლის ჩეკბოქსი */}
                <input
                    type="checkbox"
                    checked={layer.visible}
                    onChange={() => onToggle(layer)}
                    style={{ cursor: "pointer", marginRight: "5px" }}
                />

                {/* 3. ის "მრგვალი ღილაკი" (Master Toggle for Children) */}
                {hasChildren && (
                    <div
                        onClick={handleToggleAllChildren}
                        title={t("ყველა შიდა ფენის მართვა")}
                        style={{
                            width: "28px",
                            height: "18px",
                            backgroundColor: "#333", // მუქი ფონი, როგორც სურათზეა
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: anyChildVisible ? "flex-end" : "flex-start",
                            padding: "0 3px",
                            cursor: "pointer",
                            marginRight: "8px",
                            border: "1px solid #555",
                            transition: "all 0.2s ease"
                        }}
                    >
                        {/* პატარა თეთრი წრე შიგნით */}
                        <div style={{
                            width: "12px",
                            height: "12px",
                            backgroundColor: anyChildVisible ? "#fff" : "#888",
                            borderRadius: "50%",
                            boxShadow: anyChildVisible ? "0 0 5px #fff" : "none"
                        }} />
                    </div>
                )}

                {/* 4. სიმბოლო/ლეგენდა */}
                {!hasChildren && layer.legendImage && (
                    <img src={layer.legendImage} alt="" style={{ width: "18px", height: "18px", marginRight: "5px" }} />
                )}

                {/* 5. დასახელება */}
                <label style={{
                    fontSize: "13px",
                    cursor: "pointer",
                    color: textColor,
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>
                    {layer.title}
                </label>
            </div>

            {/* რეკურსია შვილებისთვის */}
            {hasChildren && isOpen && (
                <div style={{
                    borderLeft: `1px solid ${isLight ? "#ddd" : "#555"}`,
                    marginLeft: "7px",
                    paddingLeft: "8px"
                }}>
                    {layer.sublayers.items.map((sub) => (
                        <LayerItem
                            key={sub.uniqueKey || `${layer.id}_${sub.id}`}
                            layer={sub}
                            onToggle={onToggle}
                            isLight={isLight}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default LayerItem;